import React from 'react';

/**
 * PropertySelection Component
 * Based on WorkflowSummary pattern - displays properties as clickable buttons
 */
const PropertySelection = ({ properties, action, onPropertySelect }) => {
  if (!properties || properties.length === 0) {
    return null;
  }

  const handlePropertyClick = (property) => {
    console.log('[PROPERTY_SELECTION] Property clicked:', property);
    onPropertySelect(property);
  };

  return (
    <div className="mt-3 pt-3 border-t border-gray-600/30">
      <div className="space-y-2">
        {properties.map((property, index) => (
          <button
            key={property.id || index}
            onClick={() => handlePropertyClick(property)}
            className="w-full px-4 py-3 bg-gradient-to-r from-blue-600/80 to-indigo-600/80 hover:from-blue-600 hover:to-indigo-600 text-white text-sm rounded-lg transition-all duration-200 flex items-center justify-between border border-blue-500/30"
          >
            <div className="flex items-center space-x-3 text-left">
              <span className="text-lg">🏢</span>
              <div>
                <div className="font-semibold">{property.name || property.property_name}</div>
                {property.location && (
                  <div className="text-xs text-blue-200 opacity-80">
                    {property.location}
                  </div>
                )}
              </div>
            </div>
            <span className="text-lg opacity-70">→</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PropertySelection;

